(function () {
  'use strict';

  const IMAGE_MAP = {
    // Sunglasses — Edit
    'bestsellers':            'https://cdn.shopify.com/s/files/1/IMAGE_PATH_BESTSELLERS.jpg',
    'classic black':          'https://cdn.shopify.com/s/files/1/IMAGE_PATH_CLASSIC_BLACK.jpg',
    'heritage tortoise':      'https://cdn.shopify.com/s/files/1/IMAGE_PATH_HERITAGE_TORTOISE.jpg',
    'soft oval':              'https://cdn.shopify.com/s/files/1/IMAGE_PATH_SOFT_OVAL.jpg',
    'structured rectangular': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_STRUCTURED_RECTANGULAR.jpg',

    // Sunglasses — By Collection
    'romi':        'https://cdn.shopify.com/s/files/1/0598/4265/8484/products/romi-black-707768.jpg?v=1772107750',
    'bibi':        'https://cdn.shopify.com/s/files/1/0598/4265/8484/files/Bean_Studios_for_DMY_Studios_Jan_2024_-_31_504fb603-bf8a-4736-8068-85aebe6e5280.jpg?v=1757587297',
    'valentina':   'https://cdn.shopify.com/s/files/1/0598/4265/8484/files/DMY_STUDIOS_040583_GRADDED_GRADDED.jpg?v=1773222752',
    'juno':        'https://cdn.shopify.com/s/files/1/0598/4265/8484/files/Bean_Studios_for_DMY_Studios_Jan_2024_-_7_copy_47b3d925-e5c2-4446-a2cc-39a956d11b56.jpg?v=1720712783',
    'margot':      'https://cdn.shopify.com/s/files/1/0598/4265/8484/files/Bean_Studios_for_DMY_Studios_Jan_2024_-_26_bdf7d51a-bfc4-480b-b541-cc19ae0a1f43.jpg?v=1720712786',
    'nina':        'https://cdn.shopify.com/s/files/1/0598/4265/8484/files/DMY_STUDIOS_040342_1_GRADDED_GRADDED.jpg?v=1773222752',

    // Jewellery — By Category
    'earrings':  'https://cdn.shopify.com/s/files/1/IMAGE_PATH_EARRINGS.jpg',
    'necklaces': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_NECKLACES.jpg',

    // Jewellery — By Style
    'silver': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_SILVER.jpg',
    'gold':   'https://cdn.shopify.com/s/files/1/IMAGE_PATH_GOLD.jpg',
    'pearls': 'https://cdn.shopify.com/s/files/1/IMAGE_PATH_PEARLS.jpg',
  };

  const PLACEHOLDER = 'IMAGE_PATH';

  function setImage(bannerImg, src) {
    bannerImg.removeAttribute('srcset');
    bannerImg.removeAttribute('sizes');
    bannerImg.src = src;
  }

  function init() {

    // On link hover — swap image and let it stick
    document.addEventListener('mouseover', function (e) {
      const link = e.target.closest('.mega-menu--wide a');
      if (!link) return;

      const panel = link.closest('.mega-menu--wide');
      if (!panel) return;

      const bannerImg = panel.querySelector('.mega-menu__banner img');
      if (!bannerImg) return;

      // Store default once per panel open
      if (!bannerImg.dataset.defaultSrc) {
        bannerImg.dataset.defaultSrc = bannerImg.src;
        bannerImg.dataset.defaultSrcset = bannerImg.getAttribute('srcset') || '';
        bannerImg.dataset.defaultSizes = bannerImg.getAttribute('sizes') || '';
      }

      const key = link.textContent.trim().toLowerCase();
      const newSrc = IMAGE_MAP[key];

      if (newSrc && !newSrc.includes(PLACEHOLDER)) {
        setImage(bannerImg, newSrc);
      }
    });

    // Reset only when mouse leaves the entire mega menu panel
    document.querySelectorAll('.mega-menu--wide').forEach(function (panel) {
      panel.addEventListener('mouseleave', function () {
        const bannerImg = panel.querySelector('.mega-menu__banner img');
        if (!bannerImg || !bannerImg.dataset.defaultSrc) return;
        if (bannerImg.dataset.defaultSrcset) bannerImg.setAttribute('srcset', bannerImg.dataset.defaultSrcset);
        if (bannerImg.dataset.defaultSizes) bannerImg.setAttribute('sizes', bannerImg.dataset.defaultSizes);
        bannerImg.src = bannerImg.dataset.defaultSrc;
        // Clear stored default so it re-reads fresh next open
        delete bannerImg.dataset.defaultSrc;
      });
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
